import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Layout from '../../../components/layouts/Layout'
import { httpUser } from '../../../config/BaseUrl'
import AccountInfo from './Component/AccountInfo'
import ChangePassword from './Component/ChangePassword'

function Profile() {

  const [user, setUser] = useState({})


  useEffect(() => {
    httpUser.get('/user')
      .then(res => {
        setUser(res.data)
      })
  }, [])



  return (
    <Layout>
      <div className="profile-page">
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-6'>
              <AccountInfo user={user} />
            </div>
            <div className='col-md-6'>
              <ChangePassword user={user} />
            </div>
            <div className='col-md-12'>
              <div className='card'>
                <div className='card-header'>
                  <h6 className='font-weight-bold'>Membership</h6>
                </div>
                <div className='card-body'>
                  <div className='subscriptions'>
                    <div className="subscription-current-detail text-center">
                      <p className='font-weight-bold'>Current Package Name: <span className='text-primary'>{user?.membership?.our_package?.name}</span></p>
                      <p className='font-weight-bold'>Current Package Type: <span className='text-primary'>{user?.membership?.package_type}</span></p>
                      <p className='mb-2 font-weight-bold'>Current Package Amount: <span className='text-primary'>$ {user?.membership?.amount}</span></p>
                    </div>
                    <div className='subscription-button text-center'>
                      <Link to="/event/type" className='btn btn-primary rounded-pill px-4'>Upgrade plan</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Profile